export interface ApiFailure { error?: { code?: string; message?: string; field?: string }; code?: string; message?: string }

export class ClientApiError extends Error {
  constructor(public readonly status: number, public readonly body: ApiFailure) {
    super(body.error?.message ?? body.message ?? `HTTP ${status}`);
    this.name = "ClientApiError";
  }
}

export async function request<T>(path: string, init: RequestInit = {}, workspaceId?: string): Promise<T> {
  const headers = new Headers(init.headers);
  const method = (init.method ?? "GET").toUpperCase();
  if (!(init.body instanceof FormData) && !["GET", "HEAD"].includes(method)) headers.set("Content-Type", "application/json");
  if (workspaceId !== undefined) headers.set("X-Workspace-ID", workspaceId);
  const response = await fetch(path, { ...init, headers, credentials: "include" });
  const body = await response.json().catch(() => ({})) as T | ApiFailure;
  if (!response.ok) throw new ClientApiError(response.status, body as ApiFailure);
  return body as T;
}

export const formatBaht = (satang: number): string => new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB", minimumFractionDigits: satang % 100 === 0 ? 0 : 2 }).format(satang / 100);
export const formatNumber = (value: number): string => new Intl.NumberFormat("th-TH").format(value);
